import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectCompanyInfo } from '../../common/header/companyInfo/store/slice'
import useGetSettingFinancialStatement from '../common/useGetSettingFinancialStatement'
import { getDataThunk } from './helper'
import { selectPanelId } from './store/slice'
import { getDefaultTemplateForLayoutThunk } from './store/thunk'

const KEY_ORGANIZATION_ID = 'organizationIdFinanicalAnalysis'

const useCallApi = () => {
  const dispatch = useDispatch()

  const settings = useGetSettingFinancialStatement()

  const locale = useSelector((state) => state.i18n.locale)
  const companyInfo = useSelector(selectCompanyInfo)
  const panelId = useSelector(selectPanelId)

  useEffect(() => {
    const organizationIdStorage = localStorage.getItem(KEY_ORGANIZATION_ID)
    if (companyInfo.organizationId) {
      if (
        !panelId.length ||
        companyInfo.organizationId !== +organizationIdStorage
      ) {
        dispatch(
          getDefaultTemplateForLayoutThunk({
            TemplateType: companyInfo.companyType,
          }),
        )
        localStorage.setItem(KEY_ORGANIZATION_ID, companyInfo.organizationId)
      }
    }
  }, [companyInfo])

  useEffect(() => {
    if (companyInfo.organizationId) {
      const param = {
        organizationId: companyInfo.organizationId,
        ...settings,
      }

      getDataThunk({ dispatch, param, companyInfo })
    }
  }, [companyInfo.organizationId, companyInfo.companyType, locale])
}

export default useCallApi
